import { useState, useEffect, useReducer } from "react";
import { Button, Card, Col, FormGroup, Input, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QueryString from "qs";
// import moment from "moment";
// import { Edit } from "react-feather";
// import Toggle from "react-toggle";
import {
  PartyData,
  deleteParty,
  exportExcelParty,
  getParties,
  updateParty,
} from "../../services/parties.service";
import { Edit, Trash2 } from "react-feather";
import FormInput from "../../components/FormInput";
import { toast } from "react-hot-toast";
import { getCities } from "../../services/city.service";
import FormSelect from "../../components/FormSelect";
import Swal from "sweetalert2";

const initialState = {
  data: [],
  page: 1,
  limit: 100,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 100,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

function Parties() {
  const [filterData, setFilterData] = useState({
    "name|code": "",
    city: "",
    gst: "",
  });
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };
  useEffect(() => {
    const { page, city } = query;
    setLoading(true);
    getParties({ page, search: filterData["name|code"], city })
      .then((response: any) => {
        setData(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [location.search]);

  const handleUpdateStatus = (id: string, status: boolean) => {
    setLoading(true);
    updateParty(id, { status }).then(() => {
      dispatch({ type: "UPDATE_STATUS", payload: { id, status } });
      getParties({ page: data.page })
        .then((response: any) => {
          setData(response.data);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const columns = [
    {
      selector: (row: any) => row.serialNumber,
      name: "S.No.",
      sortable: false,
      //   wrap: true,
      maxWidth: "70px",
      minWidth: "70px",
    },

    {
      selector: (row: PartyData) => row.name,
      name: "Party Name",
      sortable: false,
      wrap: true,
    },

    {
      selector: (row: PartyData) => row.code,
      name: "Party Code",
      sortable: false,
      wrap: true,
    },

    {
      selector: (row: PartyData) => row.categoryType,
      name: "Category",
      sortable: false,
      wrap: true,
    },

    {
      selector: (row: PartyData) => row.mobileNumber,
      name: "Mobile",
      sortable: false,
      wrap: true,
    },

    {
      selector: (row: PartyData) => row.state,
      name: "State",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: PartyData) => row.city,
      name: "City",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => row.transporter?.name || "",
      name: "Transporter",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => (
        <FormGroup switch className='p-0'>
          <Input
            className='m-1'
            type='switch'
            role='switch'
            style={{
              cursor: "pointer",
            }}
            checked={row.status}
            onClick={() => handleUpdateStatus(row.id, !row.status)}
          />
        </FormGroup>
      ),
      name: "Status",
      sortable: false,
      maxWidth: "80px",
      minWidth: "80px",
    },
    {
      selector: (row: any) => (
        <div className='d-flex justify-content-end align-items-center gap-2 w-100 pe-1'>
          <Link
            className='d-inline-flex align-items-center'
            to={`edit/${row.id}?${QueryString.stringify({
              redirect: location.pathname + location.search,
            })}`}
          >
            <Edit size={15} />
          </Link>

          <Trash2
            className='text-danger'
            style={{ cursor: "pointer" }}
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  setLoading(true);
                  deleteParty(row.id)
                    .then(() => {
                      getParties({ page: 1 })
                        .then((response: any) => {
                          setData(response.data);
                        })
                        .finally(() => {
                          setLoading(false);
                        });
                      Swal.fire("Deleted!", "The party has been deleted.", "success");
                    })
                    .catch(() => {
                      setLoading(false);
                      Swal.fire("Error!", "There was an error deleting the party.", "error");
                    });
                }
              });
            }}
            size={15}
          />
        </div>
      ),
      name: "Actions",
      sortable: false,
      right: true,
      maxWidth: "90px",
      minWidth: "90px",
    },
  ];

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };
    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };
  const handleClearFilter = () => {
    setCity("");
    setFilterData({ "name|code": "", city: "", gst: "" });
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };
  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2 page-title-row'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Party Master</h1>
        </Col>
        <Col sm='auto'>
          <div className='justify-content-between'>
            <Link
              to={`/parties/add?${QueryString.stringify({
                redirect: location.pathname + location.search,
              })}`}
              className='btn btn-sm btn-primary my-1 text-white'
            >
              Add New
            </Link>
          </div>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-hidden' style={{ height: "calc(100vh - 250px)" }}>
        <Card className='h-100 p-3 w-100'>
          <div className='d-flex flex-column h-100 rounded-0 party-data-grid-wrapper'>
            <DataGrid
              columns={columns}
              data={data}
              loading={loading}
              isFilterApplied={Object.keys(query).some((key) => key !== "page")}
              noDataTitle='No parties found'
              noDataSubtitle='There are no parties available right now.'
              noDataFilteredTitle='No parties match your filters'
              noDataFilteredSubtitle='Try changing or clearing the filter criteria.'
              filterByDate={true}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              subHeaderComponent={
                <Row className='w-100 align-items-start g-3 py-1 px-1'>
                  <Col md={2}>
                    <FormInput
                      name='name|code'
                      label='Name | Code'
                      placeholder='Search name or code'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData["name|code"]}
                    />
                  </Col>
                  <Col md={2}>
                    <FormSelect
                      id='city'
                      name='city'
                      label='City'
                      placeholder='City'
                      isAsync
                      isClearable
                      getOptions={getCities}
                      value={city}
                      onChange={(name: any, value: any) => {
                        setCity(value);
                        setFilterData({
                          ...filterData,
                          [name]: value?.id,
                        });
                      }}
                    />
                  </Col>

                  <Col md='auto'>
                    <div className='filter-action-buttons'>
                      <Button color='primary' size='sm' onClick={() => handleFilter()}>
                        Filter
                      </Button>
                      <Button color='danger' size='sm' onClick={() => handleClearFilter()}>
                        Clear
                      </Button>
                    </div>
                  </Col>
                  <Col className='ms-auto' md='auto'>
                    <div className='filter-export-button'>
                      <Button
                        color='primary'
                        size='sm'
                        onClick={() => {
                          const { page, city } = query;
                          exportExcelParty({ page, search: filterData["name|code"], city })
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Party Master.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col>
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}

export default Parties;
